/**
 * 客户工作平台模块接口列表
 */

import { base, cookieBase, baseGateway, domains, baseCaptcha } from './base'; // 导入接口域名列表
import axios from '@/utils/http'; // 导入http中创建的axios实例
//import qs from 'qs'; // 导入qs模块

const user = {
  // 登录验证账户
  postApiLogin(params) {
    // return axios.post(`${base()}/sso-web/login`, params);
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/api/login`, params);
  },
  // 登录存token
  postConfirmCompanyForLogin(params) {
    // return axios.post(`${base()}/sso-web/confirmCompanyForLogin`, params);
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/api/confirmCompanyForLogin`, params);
  },
  // 登录存token
  loginToChem(params) {
    return axios.jsonp(`${cookieBase()}/sso-web/login/setCookie`, {
      domain: `${domains.chem}`,
      name: 'autologinTiyan',
      path: '/',
      maxAge: '-1',
      value: params.token,
    });
  },
  // 退出登录
  getloginLogout(params) {
    return axios.get(`${base()}/sso-web/logout/hgb`, params);
  },
  // 退出登录
  logoutFromChem() {
    return axios.jsonp(`${cookieBase()}/sso-web/login/setCookie`, {
      domain: `${domains.chem}`,
      name: 'autologinTiyan',
      path: '/',
      maxAge: '0',
      value: null,
    });
  },
  //获取验证码
  loginGetCode(params, paramsPhoneCode) {
    return axios.get(`${base()}/uam-web/massage/send/${params}${!paramsPhoneCode ? '?messageTypeEnum=LOGIN' : ''}`);
  },
  //获取验证码 登录
  loginGetCodeLogin(params) {
    return axios.get(`${baseGateway()}/chem-gateway/chem-business/api/getVerifyCode/${params}`);
  },
  // 图片验证码 校验
  postValidCode(params) {
    return axios.post(
      `${base()}/sso-web/validCode`,
      params
      // {
      //     headers: { 'Authorization': 'JSESSIONID=AA895199CFC90DA2DD3F22DF5E18E084' }
      // }
    );
  },
  // 获取图形验证码图片
  getGetCode(params) {
    return axios.get(`${base()}/sso-web/getCode?v=${params}`, {
      responseType: 'blob',
    });
  },

  //注册-验证手机号
  userPhone(params) {
    return axios.get(`${base()}/uam-web/person/checkMobile?mobile=${params.mobile}`);
  },
  //注册
  user(params) {
    return axios.post(`${base()}/uam-web/person/register`, params);
  },

  //企业认证-公司校验////待定
  companyRegisterDraft(params) {
    return axios.get(`${base()}/uam-web/personInfo/company-register-draft`, params);
  },

  // //企业认证-公司校验
  // companyCheckPcode(x,xx) {
  //     return axios.get(`${base()}/uam-web/personInfo/check/${x}/${xx}`);
  // },
  //校验企业是否已经注册
  companyCheckFullName(x, xx) {
    return axios.get(`${base()}/uam-web/register/company/checkFullName/${x}/${xx}`);
  },
  // 查询用户是否已存在或已申请过加入某企业
  getPersonInfoCheck(params) {
    return axios.get(`${base()}/uam-web/personInfo/check/${params.chineseFullName}/${params.pCode}`);
  },
  //企业认证-附件上传
  companyCpload(params) {
    return axios.post(`${base()}/uam-web/files/upload`, params, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  //企业认证-获取公司当前管理员
  companyListAdministrator(x, xx) {
    return axios.get(`${base()}/uam-web/joinCompany/listAdministrator/${x}/${xx}`);
  },

  //企业认证-公司当前管理员
  companyApplyToAdministrator(params) {
    return axios.get(`${base()}/uam-web/joinCompany/applyToAdministrator`, params);
  },

  //企业认证注册提交
  userRegister(params) {
    return axios.post(`${base()}/uam-web/register/company/register`, params);
  },

  //企业认证注册草稿
  userRegisterSave(params) {
    return axios.post(`${base()}/uam-web/register/company`, params);
  },

  //企业认证运营平台
  applyToPlatform(params) {
    return axios.post(`${base()}/uam-web/joinCompany/applyToPlatform`, params);
  },

  //企业认证企业管理员
  applyToAdministrator(params) {
    return axios.post(`${base()}/uam-web/joinCompany/applyToAdministrator`, params);
  },

  //获取创建企业草稿信息
  getCompanyRegisterDraft(params) {
    return axios.get(`${base()}/uam-web/personInfo/company-register-draft/${params}`);
  },
  //平台新增企业-加载数据-修改企业
  getCcompanyRegisterRecord(params) {
    return axios.get(`${base()}/uam-web/personInfo/company-register-record/${params}`);
  },
  // 添加自荐商品列表
  oneselfCommodityList(params) {
    return axios.post(`${base()}/chem-interface-web/api/selectAllChemicals`, params);
  },
  // 物料列表
  postMaterielRelationMaterielList(params) {
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/query-company-ware`, params);
  },
  // 自荐文件上传
  oneselfFileUpload(params) {
    return axios.post(`${base()}/chem-gateway/chem-business/ks-company-baseinfo/fileUpload`, params);
  },
  // 自荐信息提交
  addCompanyBaseinfo(params) {
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/addCompanyBaseinfo`, params);
  },
  // 拟购基地
  selectCompanyBase() {
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/api/selectCompanyBase`);
  },
  //基地列表
  getMaterielRelationBaseList(params) {
    return axios.get(`${base()}/chem-interface-web/materielRelation/baseList?commodityNo=${params}`);
  },
  // 自荐回显
  postQueryCompanyBaseinfo(params) {
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/queryCompanyBaseinfo`, params);
  },

  // 文件上传
  postTypsFileUpload(params) {
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/typs/fileUpload`, params);
  },

  // 获取跳转链接
  getShortUrl(params) {
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/api/short-url`, params);
  },
  // 获取数字证书页面链接
  signManage() {
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/sign-manage`);
  },

  // 获取发大大会员信息
  getFddQualification(params) {
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/fdd-qualification`, params);
  },
  // 获取签章人列表
  getFddStamp(params) {
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/fdd-stamp`, params);
  },

  // 选择签章人签署
  signTask(params) {
    return axios.post(`${baseGateway()}/chem-gateway/chem-business/ks-company-baseinfo/sign-task`, params);
  },

  // 获取验证码
  getCode(params) {
    // return passportHttp.request({ url: '/v-code', method: 'POST', data });
    return axios.post(`${baseCaptcha()}/passport/B13FC657CD72`, params);
  },
};

export default user;
